module.exports = __webpack_public_path__ + "img/tangram-colorpicker.c58df79d.png";